import { render, staticRenderFns } from "./system-simulation-payment.vue?vue&type=template&id=1023758c&scoped=true"
import script from "./system-simulation-payment.vue?vue&type=script&lang=js"
export * from "./system-simulation-payment.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-payment.vue?vue&type=style&index=0&id=1023758c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023758c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1023758c')) {
      api.createRecord('1023758c', component.options)
    } else {
      api.reload('1023758c', component.options)
    }
    module.hot.accept("./system-simulation-payment.vue?vue&type=template&id=1023758c&scoped=true", function () {
      api.rerender('1023758c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/develop-manage/system-simulation-payment.vue"
export default component.exports